"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var React = _interopRequireWildcard(_react);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function SvgOk(props) {
    return React.createElement(
        "svg",
        Object.assign({
            xmlns: "http://www.w3.org/2000/svg",
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "currentColor"
        }, props),
        React.createElement(
            "g",
            { fill: "none", fillRule: "evenodd" },
            React.createElement("path", {
                fill: "currentColor",
                d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-5a1.48 1.48 0 0 0 1.06-.443l3.648-3.833c.39-.395.39-1.033 0-1.428a.993.993 0 0 0-1.414 0L11 12.772l-1.293-1.476a.993.993 0 0 0-1.414 0 1.017 1.017 0 0 0 0 1.428l1.646 1.833c.284.285.66.443 1.061.443z"
            })
        )
    );
}
exports.default = SvgOk;